import { render, staticRenderFns } from "./UserPermissionsCard.vue?vue&type=template&id=4680ffe2&scoped=true"
import script from "./UserPermissionsCard.vue?vue&type=script&lang=js"
export * from "./UserPermissionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4680ffe2",
  null
  
)

export default component.exports